import {  Component, Vue } from "vue-property-decorator"
import { getFinanceOrderStatisticalData, financeOrderStatisticalDataExport ,getDepartmentByLevel} from '@/api/financial-center'
import { delNullProperty } from '@/utils/index'
import { formatDate } from '@/utils/timeFilter'
import {UserModule} from "@/store/modules/user";
import {getDeparmentList} from "@/api/common";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";
import CommonData from "@/utils/commonData";

const projectTypeFilter = commonData.projectTypeArray

@Component({
  components:{
    MoreUsersFilter
  }
})
export default class OrderStatisticsData extends Vue {
  projectTypeFilter = projectTypeFilter //项目类型
  page = 1
  limit = 20
  total = 0
  dissertationType = ''
  createdAt = []
  souCourseName = ''
  attendSchool = ''
  specialized = ''
  grade = ''
  souCourseSchoolBegin = []
  tableData = []
  tableLoading = false
  // isReadonly = false

  exportButtonDisabled = false
  exportHeaderDialogVisible = false
  tableHeader: any = [
    { filds: 'customerName', cnFilds: '学员名称', isShow: true, id: 1 },
    { filds: 'eduCode', cnFilds: '客户识别号', isShow: true, id: 2 },
    { filds: 'source', cnFilds: '具体来源名称', isShow: true, id: 3 },
    { filds: 'marketCooperationSource', cnFilds: '合作伙伴来源', isShow: true, id: 4 },
    { filds: 'marketCooperationBackMoneyType', cnFilds: '合作伙伴回款类型', isShow: true, id: 5 },
    { filds: 'parentMarketCooperationName', cnFilds: '上级合作伙伴', isShow: true, id: 6 },
    { filds: 'code', cnFilds: '订单编号', isShow: true, id: 7 },
    { filds: 'souCoursePrice', cnFilds: '项目终端售价', isShow: true, id: 8 },
    { filds: 'price', cnFilds: '订单金额', isShow: true, id: 9 },
    { filds: 'discountPrice', cnFilds: '优惠金额', isShow: true, id: 10 },
    { filds: 'backPrice', cnFilds: '回款金额', isShow: true, id: 11 },
    { filds: 'refundPrice', cnFilds: '退款金额', isShow: true, id: 12 },
    { filds: 'dissertationType', cnFilds: '论文服务类型', isShow: true, id: 13 },
    { filds: 'caseStatus', cnFilds: '转案状态', isShow: true, id: 14 },
    { filds: 'createdAt', cnFilds: '订单创建时间', isShow: true, id: 15 },
    { filds: 'types', cnFilds: '订单类型', isShow: true, id: 16 },
    { filds: 'reason', cnFilds: '退项原因', isShow: true, id: 17 },
    { filds: 'status', cnFilds: '订单状态', isShow: true, id: 18 },
    { filds: 'companyName', cnFilds: '所属公司', isShow: true, id: 19 },
    { filds: 'backMoneyStatus', cnFilds: '回款状态', isShow: true, id: 20 },
    { filds: 'courseCode', cnFilds: 'CourseCode', isShow: true, id: 21 },
    { filds: 'souCourseName', cnFilds: '报名项目', isShow: true, id: 22 },
    { filds: 'caseAt', cnFilds: '转案时间', isShow: true, id: 23 },
    { filds: 'souCourseSchoolBegin', cnFilds: '开课时间', isShow: true, id: 24 },
    { filds: 'souTeacherName', cnFilds: '导师名称', isShow: true, id: 25 },
    { filds: 'souCourseNameTwo', cnFilds: '专业选修课', isShow: true, id: 26 },
    { filds: 'attendSchool', cnFilds: '学校', isShow: true, id: 27 },
    { filds: 'grade', cnFilds: '年级', isShow: true, id: 28 },
    { filds: 'specialized', cnFilds: '专业', isShow: true, id: 29 },
    { filds: 'phone', cnFilds: '学生手机号', isShow: true, id: 30 },
    { filds: 'weChat', cnFilds: '学生微信', isShow: true, id: 31 },
    { filds: 'email', cnFilds: '邮箱地址', isShow: true, id: 32 },
    { filds: 'souCourseType', cnFilds: '项目类型', isShow: true, id: 33 },
    { filds: 'projectTeacherUserRealName', cnFilds: '班主任/项目负责人', isShow: true, id: 34 },
    { filds: 'projectThesisUserRealName', cnFilds: '论文班主任', isShow: true, id: 35 },
    { filds: 'projectHelperUserRealName', cnFilds: '小助手', isShow: true, id: 36 },
    { filds: 'directorUserRealName', cnFilds: '订单负责人', isShow: true, id: 37 },
    { filds: 'directorDepartmentlName', cnFilds: '订单负责人所属部门', isShow: true, id: 38 },
    { filds: 'directorLevel2DepartmentlName', cnFilds: '订单负责人所属二级部门', isShow: true, id: 39 },
    { filds: 'isCredit', cnFilds: 'Laser证书', isShow: true, id: 40 },
    { filds: 'parentPhone', cnFilds: '家长手机号', isShow: true, id: 41 },
    { filds: 'remark', cnFilds: '订单备注', isShow: true, id: 42 },
    { filds: 'contractNo', cnFilds: '合同编号', isShow: true, id: 43 },
    { filds: 'adviser', cnFilds: '送生顾问', isShow: true, id: 44 },
    { filds: 'finishAt', cnFilds: '服务完成时间', isShow: true, id: 45 },
    { filds: 'finishRefundSum', cnFilds: '累计确收前退款金额', isShow: true, id: 46 },
    { filds: 'finishSurplus', cnFilds: '预收余额', isShow: true, id: 47 },
  ]
  gradeList = CommonData.gradeList
  customerName = ''
  customerEduCode = ''
  customerSource = ''
  financeOrderCode = ''
  caseStatus = ''
  directorUserId = ''
  souCourseTypeId = ''
  departmentIdList= []
  deparmentList: any = [] // 部门列表
  checkRangeDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
  accessibleList: any = []
  checkDeparmentInfo: any = [] // 选中的部门信息
  timer = null
  types = ''
  adviser = ''
  filter_cooperSource = ''
  overseasStudy = '' // 是否留学
  departmentList = []
  level2DepartmentIdList = ''
  helperUserIdList = []
  backMoneyStatus = []
  backMoneyType = ''
  companyName = ''
  isCredit = ''
  teacherUserIdList = []
  thesisUserIdList =  []
  caseAt = []
  backMoneyAt = []
  created() {
    this.getTableData()
    this.getDeparment()
  }

  handleLevalPersonl(val) {
    this.getDepartmentByLevel(val)
  }

  // 等级人员列表
  async getDepartmentByLevel(level) {
    const data: any = await getDepartmentByLevel(level)
    this.departmentList = data.departmentList
  }

  async getDeparment() {
    const data: any = await getDeparmentList()
    this.deparmentList = data
  }

  chooseDepartment(checkedKeys,checkedData){

    // 取消勾选
    const [accessibleList,getCheckedKeys] = [this.accessibleList,(this.$refs.tree as HTMLFormElement).getCheckedKeys()];
    // 循环删除this.accessibleList中的项
    for(const i in accessibleList){
      if(accessibleList[i].id == checkedKeys.id){
        this.accessibleList.splice(i,1);
        return;
      }
    }
    // 添加勾选
    const [arr,newArr] = [[],(this.$refs.tree as HTMLFormElement).getCheckedKeys()];
    arr.push(checkedKeys);
    function dealData(arr,newArr){
      for(const i in arr){
        newArr.push(arr[i].id);
        dealData(arr[i].children,newArr);
      }
    }
    // newArr代表获取出来的当前节点以及其下的所有子节点的id
    dealData(arr,newArr);
    (this.$refs.tree as HTMLFormElement).setCheckedKeys(newArr);
    // newJsonArr代表所有选中的节点
    const newJsonArr = (this.$refs.tree as HTMLFormElement).getCheckedNodes();
    this.accessibleList = newJsonArr;
    this.checkDeparmentInfo = []

    newJsonArr.map(item => {
      this.checkDeparmentInfo.push({
        department: {
          name: item.name,
          detail: null,
          id: item.id
        },
        departmentId: item.id
      })
    })

  }

  treeChange(item: any, itembol: boolean) {
    if(itembol) {
      const res = (this.$refs.tree as HTMLFormElement).getCheckedNodes()
      const arrDeptId = []
      res.forEach((item) => {
        arrDeptId.push({
          department: {
            name: item.name,
            detail: null,
            id: item.id
          },
          departmentId: item.id
        })
      })
      this.checkDeparmentInfo = arrDeptId
    } else {

      this.checkDeparmentInfo.map((t: any, i: number) => {
        if(t.departmentId === item.id){
          this.checkDeparmentInfo.splice(i, 1)
        }
      });
    }

    this.checkRangeDepartmentList = []
    this.checkDeparmentInfo.forEach((item) => {
      this.checkRangeDepartmentList.push(item.departmentId)
    })
    this.departmentIdList = this.checkRangeDepartmentList

  }

  async getTableData() {


    this.tableLoading = true

    const { allNum, financeOrderList } = await getFinanceOrderStatisticalData(delNullProperty({
      limit: this.limit,
      page: this.page,
      dissertationType: this.dissertationType,
      createdAt: this.createdAt && this.createdAt.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.createdAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.createdAt[1])) : '',
      souCourseName: this.souCourseName,
      souCourseSchoolBegin: this.souCourseSchoolBegin && this.souCourseSchoolBegin.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.souCourseSchoolBegin[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.souCourseSchoolBegin[1])) : '',
      school:this.attendSchool,
      grade:this.grade,
      specialized:this.specialized,
      customerName : this.customerName,
      customerEduCode : this.customerEduCode,
      customerSource : this.customerSource,
      financeOrderCode : this.financeOrderCode,
      caseStatus : this.caseStatus,
      directorUserId : this.directorUserId,
      souCourseTypeIdList : this.souCourseTypeId,
      departmentIdList: this.departmentIdList,
      types: this.types,
      marketCooperationSource: this.filter_cooperSource,
      overseasStudy: this.overseasStudy,
      level2DepartmentIdList: this.level2DepartmentIdList,
      helperUserIdList: this.helperUserIdList,
      backMoneyStatusList: this.backMoneyStatus,
      marketCooperationBackMoneyType: this.backMoneyType,
      companyName: this.companyName,
      isCredit: this.isCredit,
      teacherUserIdList: this.teacherUserIdList,
      thesisUserIdList: this.thesisUserIdList,
      caseAt: this.caseAt && this.caseAt.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.caseAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.caseAt[1])) : '',
      backMoneyAt: this.backMoneyAt && this.backMoneyAt.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.backMoneyAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.backMoneyAt[1])) : '',
    })) as unknown as { allNum: number; financeOrderList: any[] }
    this.tableData = financeOrderList
    this.total = allNum
    this.tableLoading = false
    // this.isReadonly = false
  }

  // 导出
  async exportExcel(keys = '') {
    this.exportButtonDisabled = true
    financeOrderStatisticalDataExport(delNullProperty({
      dissertationType: this.dissertationType,
      createdAt: this.createdAt && this.createdAt.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.createdAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.createdAt[1])) : '',
      souCourseSchoolBegin: this.souCourseSchoolBegin && this.souCourseSchoolBegin.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.souCourseSchoolBegin[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.souCourseSchoolBegin[1])) : '',
      souCourseName: this.souCourseName,
      school:this.attendSchool,
      grade:this.grade,
      specialized:this.specialized,
      customerName : this.customerName,
      customerEduCode : this.customerEduCode,
      customerSource : this.customerSource,
      financeOrderCode : this.financeOrderCode,
      caseStatus : this.caseStatus,
      directorUserId : this.directorUserId,
      souCourseTypeIdList : this.souCourseTypeId,
      departmentIdList : this.departmentIdList,
      types: this.types,
      adviser: this.adviser,
      marketCooperationSource: this.filter_cooperSource,
      overseasStudy:this.overseasStudy,
      level2DepartmentIdList:this.level2DepartmentIdList,
      helperUserIdList:this.helperUserIdList,
      backMoneyStatusList:this.backMoneyStatus,
      marketCooperationBackMoneyType: this.backMoneyType,
      companyName: this.companyName,
      isCredit: this.isCredit,
      teacherUserIdList:this.teacherUserIdList,
      thesisUserIdList:this.thesisUserIdList,
      caseAt: this.caseAt && this.caseAt.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.caseAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.caseAt[1])) : '',
      backMoneyAt: this.backMoneyAt && this.backMoneyAt.length > 1 ? formatDate('yyyy-MM-dd', new Date(this.backMoneyAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.backMoneyAt[1])) : '',
      keys,
    }))
        .then(()=>{
          this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        })
        .finally(() => {
      this.exportButtonDisabled = false
    })
  }

  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

  changeHelperUserId(e) {
    this.helperUserIdList = e.id
    this.page = 1
    this.getTableData()
  }

  changeTeacherUserId (e) {
    this.teacherUserIdList = e.id
    this.page = 1
    this.getTableData()
  }

  changeThesisUserId(e) {
    this.thesisUserIdList = e.id
    this.page = 1
    this.getTableData()
  }

  changeDirectorUserId(e) {
    this.directorUserId = e.id
    this.page = 1
    this.getTableData()
  }

}
